import React from 'react'
import cn from 'classnames'


let Label = (props) => {
    let {type, id, children} = props
    let htmlForProp = id ? {htmlFor : id} : {}

    return (
        <label
            className = {cn({
                "control-label" : type !== 'checkbox',
            })}
            {...htmlForProp}
        >
            {
                children
            }
        </label>
    )
}

export default Label


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/Label.js